var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "person",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21.5C20 20.1044 20 19.4067 19.8278 18.8389C19.44 17.5605 18.4395 16.56 17.1611 16.1722C16.5933 16 15.8956 16 14.5 16H9.5C8.10444 16 7.40665 16 6.83886 16.1722C5.56045 16.56 4.56004 17.5605 4.17224 18.8389C4 19.4067 4 20.1044 4 21.5M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8C7.5 5.51472 9.51472 3.5 12 3.5C14.4853 3.5 16.5 5.51472 16.5 8Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "password",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5V8.5C17 5.73858 14.7614 3.5 12 3.5C9.23858 3.5 7 5.73858 7 8.5V11.5M7.8 21.5H16.2C17.8802 21.5 18.7202 21.5 19.362 21.173C19.9265 20.8854 20.3854 20.4265 20.673 19.862C21 19.2202 21 18.3802 21 16.7V16.3C21 14.6198 21 13.7798 20.673 13.138C20.3854 12.5735 19.9265 12.1146 19.362 11.827C18.7202 11.5 17.8802 11.5 16.2 11.5H7.8C6.11984 11.5 5.27976 11.5 4.63803 11.827C4.07354 12.1146 3.6146 12.5735 3.32698 13.138C3 13.7798 3 14.6198 3 16.3V16.7C3 18.3802 3 19.2202 3.32698 19.862C3.6146 20.4265 4.07354 20.8854 4.63803 21.173C5.27976 21.5 6.11984 21.5 7.8 21.5Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "F6C23E",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM9.0625 5.9375C9.0625 5.42188 9.48438 5 10 5C10.5156 5 10.9375 5.41992 10.9375 5.9375V10.9375C10.9375 11.4551 10.5176 11.875 10 11.875C9.48242 11.875 9.0625 11.457 9.0625 10.9375V5.9375ZM10 15.625C9.32187 15.625 8.77188 15.075 8.77188 14.3969C8.77188 13.7188 9.32148 13.1687 10 13.1687C10.6785 13.1687 11.2281 13.7188 11.2281 14.3969C11.2266 15.0742 10.6797 15.625 10 15.625Z",
    fill: "#F6C23E"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "E74A3B",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM6.83594 8.12891L8.67578 9.96484L6.83594 11.8359C6.47266 12.2031 6.47266 12.7969 6.83594 13.1289C7.20312 13.5273 7.79688 13.5273 8.12891 13.1289L9.96484 11.3242L11.8359 13.1289C12.2031 13.5273 12.7969 13.5273 13.1289 13.1289C13.5273 12.7969 13.5273 12.2031 13.1289 11.8359L11.3242 9.96484L13.1289 8.12891C13.5273 7.79688 13.5273 7.20312 13.1289 6.83594C12.7969 6.47266 12.2031 6.47266 11.8359 6.83594L9.96484 8.67578L8.12891 6.83594C7.79688 6.47266 7.20312 6.47266 6.83594 6.83594C6.47266 7.20312 6.47266 7.79688 6.83594 8.12891Z",
    fill: "#E74A3B"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "3CBC81",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM14.5234 8.27344C14.9492 7.84766 14.9492 7.15234 14.5234 6.72656C14.0977 6.30078 13.4023 6.30078 12.9766 6.72656L8.75 10.9531L7.02344 9.22656C6.59766 8.80078 5.90234 8.80078 5.47656 9.22656C5.05078 9.65234 5.05078 10.3477 5.47656 10.7734L7.97656 13.2734C8.40234 13.6992 9.09766 13.6992 9.52344 13.2734L14.5234 8.27344Z",
    fill: "#3CBC81"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 46 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.667 0h-34.667c-2.206 0-4 1.794-4 4v24c0 2.206 1.794 4 4 4h34.667c2.206 0 4-1.794 4-4v-24c0-2.206-1.794-4-4-4zM38.667 2.667c0.181 0 0.353 0.038 0.511 0.103l-17.844 15.466-17.844-15.466c0.158-0.066 0.33-0.103 0.511-0.103h34.667zM38.667 29.333h-34.667c-0.736 0-1.333-0.598-1.333-1.333v-22.413l17.793 15.421c0.251 0.217 0.563 0.326 0.874 0.326s0.622-0.108 0.874-0.326l17.793-15.421v22.413c0 0.736-0.598 1.333-1.333 1.333z",
    fill: "#fafafa"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.189,
    d: "M3.791 24.546c.077-.696.116-1.045.221-1.37.093-.289.226-.564.393-.817.188-.285.436-.533.932-1.029L22.667 4A3.77 3.77 0 1 1 28 9.333l-17.33 17.33c-.495.495-.743.743-1.029.932a3.382 3.382 0 0 1-.817.393c-.325.105-.674.144-1.37.221l-4.121.458.458-4.121z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fb",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.238 16.092C31.238 7.626 24.415.762 16 .762S.762 7.626.762 16.092c0 7.651 5.571 13.994 12.857 15.145V20.525h-3.87v-4.433h3.87v-3.377c0-3.841 2.276-5.965 5.756-5.965 1.667 0 3.412.3 3.412.3v3.773h-1.922c-1.892 0-2.484 1.181-2.484 2.395v2.874h4.226l-.675 4.433h-3.55v10.713c7.286-1.15 12.857-7.493 12.857-15.146z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-insta",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.349 3.301a6.368 6.368 0 0 1 6.349 6.349v12.698a6.368 6.368 0 0 1-6.349 6.349H9.651a6.37 6.37 0 0 1-6.349-6.349V9.65a6.37 6.37 0 0 1 6.349-6.349h12.698zm0-2.539H9.651c-4.889 0-8.889 4-8.889 8.889v12.698c0 4.889 4 8.889 8.889 8.889h12.698c4.889 0 8.889-4 8.889-8.889V9.651c0-4.889-4-8.889-8.889-8.889z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.254 9.654a1.905 1.905 0 1 1 .003-3.812 1.905 1.905 0 0 1-.004 3.813zM16 10.923a5.079 5.079 0 1 1 .003 10.156 5.079 5.079 0 0 1-.004-10.155zm0-2.54a7.62 7.62 0 0 0-7.473 9.105 7.624 7.624 0 0 0 5.986 5.986 7.616 7.616 0 0 0 7.821-3.24 7.62 7.62 0 0 0-6.335-11.853z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo_desc",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    d: "M8.727 0h14.545a8.727 8.727 0 0 1 8.727 8.727v14.545a8.727 8.727 0 0 1-8.727 8.727H8.727A8.727 8.727 0 0 1 0 23.272V8.727A8.727 8.727 0 0 1 8.727 0z",
    style: {
      fill: "var(--color1, #8baa36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.454,
    d: "M7.273 7.347v3.966c0 1.132.494 2.135 1.26 2.784.375.317.622.746.622 1.221v6.62c0 .736.633 1.333 1.412 1.333s1.412-.597 1.412-1.333v-6.62c0-.476.248-.904.622-1.221a3.635 3.635 0 0 0 1.26-2.784v0m-3.294.404V7.273m12.706.935c0-.491-.422-.889-.941-.889h-.941c-1.559 0-2.823 1.194-2.823 2.667v5.333c0 1.159.788 2.136 1.882 2.503v4.117c0 .736.633 1.333 1.412 1.333s1.412-.597 1.412-1.333V8.207z",
    style: {
      stroke: "var(--color2, #fafafa)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo_mob",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    d: "M9.6 0h12.8A9.6 9.6 0 0 1 32 9.6v12.8a9.6 9.6 0 0 1-9.6 9.6H9.6A9.6 9.6 0 0 1 0 22.4V9.6A9.6 9.6 0 0 1 9.6 0z",
    style: {
      fill: "var(--color1, #8baa36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M7.039 7.117v4.072c0 1.163.507 2.192 1.294 2.858.385.326.639.766.639 1.254v6.797c0 .756.649 1.369 1.449 1.369s1.449-.613 1.449-1.369v-6.797c0-.488.254-.928.639-1.254.787-.666 1.294-1.696 1.294-2.858v0m-3.383.414V7.04M23.466 8c0-.504-.433-.913-.966-.913h-.966c-1.601 0-2.899 1.226-2.899 2.738v5.476c0 1.19.809 2.193 1.933 2.57v4.227c0 .756.649 1.369 1.449 1.369s1.449-.613 1.449-1.369V8z",
    style: {
      stroke: "var(--color2, #fafafa)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z",
    style: {
      fill: "var(--color1, #8baa36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M16 9v14m-7-7h14",
    style: {
      stroke: "var(--color3, #fff)"
    }
  })), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.667 25.333c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M28.001 28l-5.8-5.8"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-tweeter",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6.233c-1.2.522-2.47.865-3.77 1.02a6.502 6.502 0 0 0 2.889-3.573 13.189 13.189 0 0 1-4.171 1.567A6.623 6.623 0 0 0 22.154 3.2c-3.628 0-6.564 2.893-6.564 6.46-.003.496.054.991.169 1.473A18.723 18.723 0 0 1 2.226 4.38a6.386 6.386 0 0 0-.893 3.247c0 2.24 1.169 4.22 2.933 5.38a6.499 6.499 0 0 1-2.985-.807v.08c0 3.133 2.267 5.74 5.267 6.333a6.733 6.733 0 0 1-1.729.227 6.31 6.31 0 0 1-1.234-.12c.834 2.567 3.261 4.433 6.137 4.487a13.304 13.304 0 0 1-8.155 2.767A13.671 13.671 0 0 1 0 25.881a18.578 18.578 0 0 0 10.049 2.92c12.091 0 18.696-9.847 18.696-18.387 0-.28-.007-.56-.021-.833a13.222 13.222 0 0 0 3.275-3.347z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.723,
    d: "M26.667 28v-2.667A5.334 5.334 0 0 0 21.334 20H10.667a5.334 5.334 0 0 0-5.333 5.333V28M16 14.667a5.333 5.333 0 1 0 0-10.666 5.333 5.333 0 0 0 0 10.666z",
    style: {
      stroke: "var(--color4, #c4c4c4)"
    }
  })), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-youtube",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.794 9.299c0-2.812-2.069-5.075-4.626-5.075A227.205 227.205 0 0 0 16.564 4h-1.125c-3.6 0-7.138.063-10.601.225C2.288 4.225.219 6.5.219 9.312A92.957 92.957 0 0 0 0 15.986a96.87 96.87 0 0 0 .213 6.681c0 2.812 2.069 5.094 4.619 5.094 3.638.169 7.37.244 11.164.237a224.3 224.3 0 0 0 11.164-.237c2.557 0 4.626-2.281 4.626-5.094.15-2.231.219-4.456.213-6.687a90.948 90.948 0 0 0-.204-6.681zM12.94 22.118V9.837l9.064 6.137-9.064 6.144z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.586l-7.071-7.071-1.414 1.414 7.071 7.071-7.071 7.071 1.414 1.414 7.071-7.071 7.071 7.071 1.414-1.414-7.071-7.071 7.071-7.071-1.414-1.414-7.071 7.071z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7429,
    d: "M21.333 8v-1.067c0-1.493 0-2.24-0.291-2.811-0.256-0.502-0.664-0.91-1.165-1.165-0.57-0.291-1.317-0.291-2.811-0.291h-2.133c-1.493 0-2.24 0-2.811 0.291-0.502 0.256-0.91 0.664-1.165 1.165-0.291 0.57-0.291 1.317-0.291 2.811v1.067M13.333 15.333v6.667M18.667 15.333v6.667M4 8h24M25.333 8v14.933c0 2.24 0 3.36-0.436 4.216-0.384 0.753-0.995 1.365-1.748 1.748-0.856 0.436-1.976 0.436-4.216 0.436h-5.867c-2.24 0-3.36 0-4.216-0.436-0.753-0.384-1.365-0.995-1.748-1.748-0.436-0.856-0.436-1.976-0.436-4.216v-14.933"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M21.76 14.72v-3.84c0-3.535-2.865-6.4-6.4-6.4s-6.4 2.865-6.4 6.4v3.84M9.984 27.52h10.752c2.151 0 3.226 0 4.047-0.419 0.723-0.368 1.31-0.956 1.678-1.678 0.419-0.822 0.419-1.897 0.419-4.047v-0.512c0-2.151 0-3.226-0.419-4.047-0.368-0.723-0.956-1.31-1.678-1.678-0.822-0.419-1.897-0.419-4.047-0.419h-10.752c-2.151 0-3.226 0-4.047 0.419-0.723 0.368-1.31 0.956-1.678 1.678-0.419 0.822-0.419 1.897-0.419 4.047v0.512c0 2.151 0 3.226 0.419 4.047 0.368 0.723 0.956 1.31 1.678 1.678 0.821 0.419 1.897 0.419 4.047 0.419z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M2.56 9.6l10.451 7.316c0.846 0.593 1.27 0.889 1.73 1.003 0.407 0.101 0.832 0.101 1.238 0 0.46-0.115 0.883-0.411 1.73-1.003l10.451-7.316M8.704 26.24h13.312c2.151 0 3.226 0 4.047-0.419 0.723-0.368 1.31-0.956 1.678-1.678 0.419-0.822 0.419-1.897 0.419-4.047v-8.192c0-2.151 0-3.226-0.419-4.047-0.368-0.723-0.956-1.31-1.678-1.678-0.822-0.419-1.897-0.419-4.047-0.419h-13.312c-2.151 0-3.226 0-4.047 0.419-0.723 0.368-1.31 0.956-1.678 1.678-0.419 0.821-0.419 1.897-0.419 4.047v8.192c0 2.151 0 3.226 0.419 4.047 0.368 0.723 0.956 1.31 1.678 1.678 0.821 0.419 1.897 0.419 4.047 0.419z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M25.6 27.52c0-1.786 0-2.679-0.22-3.406-0.496-1.636-1.777-2.917-3.413-3.413-0.727-0.22-1.62-0.22-3.406-0.22h-6.4c-1.786 0-2.679 0-3.406 0.22-1.636 0.496-2.917 1.777-3.413 3.413-0.22 0.727-0.22 1.62-0.22 3.406M21.12 10.24c0 3.181-2.579 5.76-5.76 5.76s-5.76-2.579-5.76-5.76c0-3.181 2.579-5.76 5.76-5.76s5.76 2.579 5.76 5.76z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.1895,
    d: "M3.791 24.546c0.077-0.696 0.116-1.045 0.221-1.37 0.093-0.289 0.226-0.564 0.393-0.817 0.188-0.285 0.436-0.533 0.932-1.029l17.33-17.33c1.473-1.473 3.861-1.473 5.333 0v0c1.473 1.473 1.473 3.861 0 5.333l-17.33 17.33c-0.495 0.495-0.743 0.743-1.029 0.932-0.253 0.167-0.528 0.299-0.817 0.393-0.325 0.105-0.674 0.144-1.37 0.221l-4.121 0.458 0.458-4.121z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8baa36",
    style: {
      fill: "var(--color1, #8baa36)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color2, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 9v14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color2, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M9 16h14"
  })), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.667 25.333c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M28 28l-5.8-5.8"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M4 16h24M4 8h24M4 24h16"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.1895,
    d: "M4.632 16h16.842"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.1895,
    d: "M15.158 7.158l8.842 8.842-8.842 8.842"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-clock",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9714,
    d: "M15.998 29.334c7.364 0 13.333-5.97 13.333-13.333s-5.97-13.333-13.333-13.333-13.333 5.97-13.333 13.333c0 7.364 5.97 13.333 13.333 13.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9714,
    d: "M16 8v8l5.333 2.667"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pick",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--color1, #8baa36)"
    },
    d: "M24.876 3.239c0.867-1.279 2.607-1.613 3.886-0.746s1.613 2.607 0.746 3.886l-15.174 22.381c-1.11 1.637-3.521 1.637-4.631 0l-7.207-10.631c-0.867-1.279-0.533-3.019 0.746-3.886s3.019-0.533 3.886 0.746l4.892 7.215 12.858-18.966z"
  })), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-img",
    width: 50,
    height: 50,
    viewBox: "0 0 64 64",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.381 22.8571V13.696C56.3811 12.0826 55.7414 10.535 54.6023 9.39244C53.4631 8.24988 51.9175 7.60557 50.3041 7.60073L41.143 7.5733M56.381 41.1428V50.2857C56.381 51.9022 55.7389 53.4526 54.5958 54.5957C53.4527 55.7387 51.9024 56.3809 50.2858 56.3809H41.143M22.8572 7.5733L13.6961 7.60378C12.0827 7.60862 10.5371 8.25293 9.39792 9.39549C8.2588 10.538 7.61913 12.0856 7.61914 13.699V22.8571M22.8572 56.3809H13.7144C12.0978 56.3809 10.5475 55.7387 9.40439 54.5957C8.26132 53.4526 7.61914 51.9022 7.61914 50.2857V41.1428",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37.5C33.25 37.5 34.3127 37.0627 35.188 36.188C36.0627 35.3127 36.5 34.25 36.5 33C36.5 31.75 36.0627 30.6873 35.188 29.812C34.3127 28.9373 33.25 28.5 32 28.5C30.75 28.5 29.6873 28.9373 28.812 29.812C27.9373 30.6873 27.5 31.75 27.5 33C27.5 34.25 27.9373 35.3127 28.812 36.188C29.6873 37.0627 30.75 37.5 32 37.5ZM24 41C23.45 41 22.9793 40.8043 22.588 40.413C22.196 40.021 22 39.55 22 39V27C22 26.45 22.196 25.9793 22.588 25.588C22.9793 25.196 23.45 25 24 25H27.15L29 23H35L36.85 25H40C40.55 25 41.021 25.196 41.413 25.588C41.8043 25.9793 42 26.45 42 27V39C42 39.55 41.8043 40.021 41.413 40.413C41.021 40.8043 40.55 41 40 41H24Z",
    fill: "white"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "close-btn",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M25 7l-18 18"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M25 25l-18-18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.6873ee9bdd2851c28cac43ff0d2add1d.svg";
export { ForwardRef as ReactComponent };